module.exports = __webpack_public_path__ + "img/brand-canonical-examples.797284d6.svg";